import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
    selector: 'sl-support-button',
    imports: [MatIconModule],
    templateUrl: './support-button.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrls: ['./support-button.component.scss']
})
export class SupportButtonComponent {
    @Input() public supportUrl: string;
}
